<script>
  import { BAR_HOLD_DURATION_MS } from '../timing.js'

  let { routeProgress = 0, routeLoading = false } = $props()

  let progress = $state(0)
  let visible = $state(false)
  let completeTimer

  $effect(() => {
    const p = routeProgress || 0

    if (p > 0 && p < 1) {
      progress = p
      visible = true
      clearTimeout(completeTimer)
    } else if (p >= 1 && visible) {
      progress = 1
      completeTimer = setTimeout(() => {
        visible = false
        progress = 0
      }, BAR_HOLD_DURATION_MS)
    } else if (p === 0 && !routeLoading) {
      // Route finished without ever showing the bar (fast nav)
      progress = 0
    }

    return () => clearTimeout(completeTimer)
  })
</script>

{#if visible}
  <div class="fixed top-0 left-0 right-0 z-[9999] h-[3px] bg-muted">
    <!-- BAR_TRANSITION_MS (300) -->
    <div
      class="h-full bg-primary transition-all duration-300 ease-out"
      style="width: {progress * 100}%"
    />
  </div>
{/if}
